import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Form, Checkbox, Tooltip, message } from 'antd';
import { Key, KeyWrapper, RequestParameter, Pad } from './index.style';
import Markdown from '../../../markdown/Markdown';
import InputWithEnums from './InputWithEnums';
import TextInputWithEnums from './TextInputWithEnums';
import NumberInput from './NumberInput';
import BooleanInput from './BooleanInput';

function ParameterRow(_ref) {
  var {
    index,
    parameter
  } = _ref;
  var {
    name,
    required,
    description,
    type,
    format,
    enums
  } = parameter;

  var checkParameter = (rule, value) => {
    var check = required && (_.isNil(value) || value === '');

    if (!check) {
      return Promise.resolve();
    }

    var msg = "".concat(name, " is a required parameter.");
    message.warning(msg);
    return Promise.reject(msg);
  };

  var inputProps = {
    name,
    options: enums,
    required,
    checkParameter // onChange: setParamValue,

  };
  var inputOptions = {
    // Booleans
    bool: /*#__PURE__*/React.createElement(BooleanInput, inputProps),
    boolean: /*#__PURE__*/React.createElement(BooleanInput, inputProps),
    // Numbers
    float: /*#__PURE__*/React.createElement(NumberInput, inputProps),
    int: /*#__PURE__*/React.createElement(NumberInput, inputProps),
    integer: /*#__PURE__*/React.createElement(NumberInput, inputProps),
    number: /*#__PURE__*/React.createElement(NumberInput, inputProps),
    string: /*#__PURE__*/React.createElement(InputWithEnums, inputProps),
    graphql: /*#__PURE__*/React.createElement(TextInputWithEnums, inputProps),
    json: /*#__PURE__*/React.createElement(TextInputWithEnums, inputProps)
  };
  var inputComponent = inputOptions[format] || inputOptions[type] || inputOptions.string;
  return /*#__PURE__*/React.createElement(RequestParameter, {
    index: index
  }, /*#__PURE__*/React.createElement(Form.Item, {
    name: [name, 'checked'],
    valuePropName: "checked"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    style: {
      marginLeft: 8,
      marginRight: 10
    },
    disabled: !!required
  })), /*#__PURE__*/React.createElement(Tooltip, {
    title: /*#__PURE__*/React.createElement(Markdown, {
      markdown: description
    }),
    mouseEnterDelay: 0.6
  }, /*#__PURE__*/React.createElement(KeyWrapper, null, /*#__PURE__*/React.createElement(Key, {
    required: required
  }, name))), inputComponent);
}

ParameterRow.propTypes = {
  parameter: PropTypes.object
};
ParameterRow.defaultProps = {
  parameter: {
    in: 'query',
    name: 'null',
    required: true,
    default: 'test'
  }
};
export default ParameterRow;